interface BalancePanelInputs {
  /** Both account queries have answered. */
  settled: boolean;
  /** The company's own Outpave accounts. */
  internalCount: number;
  /** Linked external cards and banks. */
  externalCount: number;
}

/**
 * Whether the dashboard draws the balance panel.
 *
 * The rule is "unless this is a BYOC-only company, which has no Outpave balance
 * to draw". The subtlety, and the reason this is a named function with tests:
 * the two counts come from independent queries and both start at zero, so
 * mid-load "no internal accounts, some external ones" is indistinguishable from
 * a real BYOC-only company. Answering before both have landed made the panel
 * mount, drop out for a frame, and come back, reflowing the row each time.
 *
 * So an unsettled pair is not an answer: the panel stays and shows its own
 * skeletons. That leaves exactly one transition, and only for a company that
 * really is BYOC-only.
 */
export const showsBalancePanel = ({
  settled,
  internalCount,
  externalCount,
}: BalancePanelInputs): boolean =>
  !settled || internalCount > 0 || externalCount === 0;

export default showsBalancePanel;
